import { mutatorAction } from "satcheljs";
import type { AnimationPreference } from "owa-outlook-service-option-store";
import messageListLayoutStore from "../store/messageListLayoutStore";

export const selectMessageHeightOptionMutator: (useSingleLineMessageStyle: boolean) => void = mutatorAction("selectMessageHeightOption", function selectMessageHeightOption(useSingleLineMessageStyle: boolean): void {
    messageListLayoutStore().useSingleLineMessageStyle = useSingleLineMessageStyle;
});

export const setShowPreviewLinesOptionMutator: (previewLines: number | null) => void = mutatorAction("setShowPreviewLinesOptionInListView", function setShowPreviewLinesOptionInListView(previewLines: number | null): void {
    messageListLayoutStore().showPreviewLinesInListView = previewLines;
});

export const selectTempPreviewLinesOptionMutator: (previewLines: number | null) => void = mutatorAction("selectTempPreviewLinesOptionInListView", function selectTempPreviewLinesOptionInListView(previewLines: number | null): void {
    messageListLayoutStore().tempPreviewLinesInListView = previewLines;
});

export const setPersonaCheckboxDisplayMutator: (personaCheckboxDisplay: number | null) => void = mutatorAction("setPersonaCheckboxDisplay", function setPersonaCheckboxDisplay(personaCheckboxDisplay: number | null): void {
    messageListLayoutStore().personaCheckboxDisplay = personaCheckboxDisplay;
});

export const selectTempPersonaCheckboxDisplayMutator: (personaCheckboxDisplay: number | null) => void = mutatorAction("selectTempPersonaCheckboxDisplay", function selectTempPersonaCheckboxDisplay(personaCheckboxDisplay: number | null): void {
    messageListLayoutStore().tempPersonaCheckboxDisplay = personaCheckboxDisplay;
});

export const selectSenderImageOptionMutator: (showSenderImage: boolean) => void = mutatorAction("selectSenderImageOption", function selectSenderImageOption(showSenderImage: boolean): void {
    messageListLayoutStore().showSenderImageInListView = showSenderImage;
});
export const selectSenderSubjectOptionMutator: (senderOnTop: boolean) => void = mutatorAction("selectSenderSubjectOption", function selectSenderSubjectOption(senderOnTop: boolean): void {
    messageListLayoutStore().showSenderOnTopInListView = senderOnTop;
});

export const selectInlinePreviewsOptionMutator: (isInlinePreviewsEnabled: boolean) => void = mutatorAction("selectInlinePreviewsOption", function selectInlinePreviewsOption(isInlinePreviewsEnabled: boolean): void {
    messageListLayoutStore().inlinePreviewsEnabled = isInlinePreviewsEnabled;
});

export const selectDateHeadersOptionMutator: (isDateHeadersEnabled: boolean) => void = mutatorAction("selectDateHeadersOption", function selectDateHeadersOption(isDateHeadersEnabled: boolean): void {
    messageListLayoutStore().dateHeadersEnabled = isDateHeadersEnabled;
});

export const selectAnimationsOptionMutator: (animationPreference: AnimationPreference) => void = mutatorAction("selectAnimationsOption", function selectAnimationsOption(animationPreference: AnimationPreference): void {
    messageListLayoutStore().animationPreference = animationPreference;
});
